<main class="container">
    <img src="assets/common/less.svg" style="visibility: hidden;">

    <h2 class="title text-center">
        Proposta de áreas tecnológicas
    </h2>

    <div class="content">
        <div class="text-container text-justify">
            <p class="paragraph">
                A partir das determinações da Resolução CNE/CP 01/2021, o Catálogo Nacional de Cursos Superiores de Tecnologia
                (CNCST) e o Catálogo Nacional de Cursos Técnicos (CNCT) passarão a contar com divisão dos eixos tecnológicos em
                áreas tecnológicas.
            </p>
            <p class="paragraph">
                As áreas tecnológicas aqui propostas foram criadas a partir da discussão com grupos de técnicos, tecnólogos,
                empresários, docentes e conselhos profissionais. Foram delimitadas segundo a afinidade tecnológica e observados
                os conceitos e estrutura utilizados pela Classificação Internacional Normalizada da Educação. Portanto, cursos
                técnicos e cursos superiores de tecnologia identificados por tecnologias afins serão enquadrados nas mesmas áreas
                e eixos tecnológicos. 
            </p>
            <p class="paragraph">
                Abaixo você encontra todos os cursos técnicos e tecnológicos em suas respectivas áreas e eixos. Você pode opinar
                quanto à pertinência do enquadramento e a descrição da área. Caso julgue que uma nova área deva ser criada você
                pode também fazer esta sugestão.
            </p>
        </div>

        <div class="eixos content">
            <div class="eixo" *ngFor="let eixo of dadosConsulta">
                <div class="title-container" appDisplay>
                    <button type="button" class="display-btn display cursor-pointer">Expandir</button>
                    <h3 class="cursor-pointer">{{ eixo.nome }}</h3>
                </div>

                <div class="list-content toggle">
                    <p class="eixo-paragraph paragraph text-justify">{{ eixo.descricao }}</p>
                    <div class="area" *ngFor="let area of eixo.areas">
                        <div class="title-container areas" appDisplay>
                            <button type="button" class="display-btn cursor-pointer">Expandir</button>
                            <h3 class="cursor-pointer">
                                {{area.nome != "Sem Área Tecnológica"? 'Área Tecnológica: ' + area.nome : 'Cursos Sem Área Tecnológica'}}
                            </h3>
                        </div>

                        <div class="list-content cursos toggle">
                            <p class="area-paragraph paragraph text-justify">{{ area.descricao }}</p>
                            <div class="title-container cursos curso" appDisplay>
                                <button type="button" class="display-btn cursor-pointer">Expandir</button>
                                <h3 class="cursor-pointer">Cursos Técnicos</h3>
                            </div>
                            <div class="list-content toggle">
                                <h3 class="curso-tecnico curso" *ngFor="let cursoTec of area.cursosCnct">{{ cursoTec.nome }}</h3>
                            </div>
                            <div class="title-container cursos curso" appDisplay>
                                <button type="button" class="display-btn cursor-pointer">Expandir</button>
                                <h3 class="cursor-pointer">Cursos Superiores de Tecnologia</h3>
                            </div>
                            <div class="list-content toggle">
                                <h3 class="curso-superior curso" *ngFor="let cursoSup of area.cursosCncst">{{ cursoSup.nome }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <button class="btn rounded-pill btn-lg btn-primary" routerLink="/envie-sugestao-areas">Envie sua sugestão</button>

    <div class="forms-buttons">
        <div class="redirect-form">
            <h2 class="subtitle">Envie sugestões para o Catálogo Nacional de Cursos Superiores de Tecnologia</h2>
            <button class="btn rounded-pill btn-md btn-primary" routerLink="/aviso-sugestao">Clique aqui</button>
        </div>
        <div class="redirect-form">
            <h2 class="subtitle">Envie sugestões para a carga horária mínima presencial dos cursos técnicos</h2>
            <button class="btn rounded-pill btn-md btn-primary" routerLink="/aviso-sugestao-cnct">Clique aqui</button>
        </div>
    </div>
</main>